/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/**
 * Strips the `freshInstall` query parameter from the URL bar so an
 * accidental iframe reload does not trigger a second storage wipe.
 */
export function removeFreshInstallFromUrl(): void {
    const url: URL = new URL(window.location.href);
    url.searchParams.delete('freshInstall');
    window.history.replaceState({}, document.title, url.toString());
}
